import React from 'react';

interface ChevronCircleRightIconProps {
  size?: number;
  width?: number;
  height?: number;
  backgroundColor?: string;
  strokeColor?: string;
  className?: string;
}

const ChevronCircleRightIcon: React.FC<ChevronCircleRightIconProps> = ({
  size = 20,
  width,
  height,
  backgroundColor = '#5B8CEC',
  strokeColor = 'white',
  className = '',
}) => {
  const iconWidth = width || size;
  const iconHeight = height || size;

  return (
    <svg
      width={iconWidth}
      height={iconHeight}
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <circle
        cx='9.99756'
        cy='10.9155'
        r='10.0015'
        fill={backgroundColor}
      />
      <path
        d='M7.6875 15.5329L11.95 11.2704C12.1453 11.0751 12.1453 10.7586 11.95 10.5633L7.6875 6.30078'
        stroke={strokeColor}
        strokeLinecap='round'
      />
    </svg>
  );
};

export default ChevronCircleRightIcon;
